import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { FormHelper } from '@osapp/helpers';
import { DestroyableComponentBase } from '@osapp/modules/utils/components/destroyable-component-base';
import { CapacitorPluginSce } from 'capacitor-plugin-sce';
import { defer, EMPTY, from, Observable, of } from 'rxjs';
import { catchError, filter, switchMap, takeUntil, tap } from 'rxjs/operators';
import { SceEventService } from '../../../../sce4Mobile/sce-event.service';
import { PanneauService } from '../../../services/panneau.service';
import { SnackbarService } from '../../../services/snackbar.service';

@Component({
	selector: 'di-panneau-tester-lecteur',
	templateUrl: './panneau-tester-lecteur.component.html',
	styleUrls: ['./panneau-tester-lecteur.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class PanneauTesterLecteurComponent extends DestroyableComponentBase implements OnInit, OnDestroy{

	public demandeCodeCPS : boolean = false;
	public cpsSaisie : string = "";
	public sceLogs: string[] = [];
	
	constructor(
		private svcPanneau: PanneauService,
		private svcSceEvent : SceEventService,
		private svcSnackbar: SnackbarService,        
		public cdr: ChangeDetectorRef
	) {
		super();
	 }

	public ngOnInit() {

		this.svcSceEvent.sce_log$.pipe(
			takeUntil(this.destroyed$),
			tap(msg => {
				if (msg) {
					this.sceLogs.push(msg);
					this.cdr.detectChanges();
				}
			})
			).subscribe();


		this.listenToSceStatus();
		try {
			console.warn('[COMP] Connexion au SCE en cours...');
			from(CapacitorPluginSce.connect()).pipe(
				takeUntil(this.destroyed$)
			).subscribe();
		} catch (err) {
			console.error('[COMP] Erreur lors du connectToSCE initial', err);
			this.svcSceEvent.emitStatus('error');
		}
		return;
	}

	public override ngOnDestroy() {
		from(CapacitorPluginSce.disconnect()).pipe(
			takeUntil(this.destroyed$)
		).subscribe();
		super.ngOnDestroy();
	}

	private listenToSceStatus() {
		this.svcSceEvent.emitStatus("idle");

		this.svcSceEvent.sceStatus$.pipe(
			takeUntil(this.destroyed$),
			filter(sceStatus => !!sceStatus),
			switchMap((sceStatus) => {
				switch (sceStatus.status) {
					case 'connected':
						console.warn('[COMP] Le SCE est prêt.');
						return from(CapacitorPluginSce.connectToDevice());
					case 'waiting-lecteur':
						return of(sceStatus);
					case 'error':
						console.warn('[COMP] Une erreur a été détectée dans le processus SCE.');
						this.cdr.detectChanges();
						return of(sceStatus);
					case 'waiting-code':
						console.warn('[COMP] Demande du code porteur.');
						this.demandeCodeCPS = true;
						this.cdr.detectChanges();
						return defer(() => new Observable(subscriber => {
							requestAnimationFrame(() => {
								subscriber.next();
								subscriber.complete();
							});
						}));
					case 'ready-code':	
						console.warn('[COMP] Code porteur déjà saisi, lancement de la lecture CV ...');
						return of(sceStatus);
					case 'ready':
						console.warn('[COMP] Le lecteur est prêt.');
						return of(sceStatus);
				}
				this.cdr.detectChanges();
				return of(sceStatus);
			}),
			catchError(err => {
				console.error('[COMP] SCE status handling error:', err.message);
				this.svcSnackbar.showToast("error", "bottom center", `La connexion au lecteur SCE a échoué. Essayez de redémarrer le lecteur ou de relancer l'application.`, null, null, null, "6000");
				this.svcPanneau.close();
				return EMPTY;
			})
		).subscribe();
	}

	public sendCodeCPS(){
		console.warn(`[COMP] Envoi du code CPS : ${this.cpsSaisie} ...`);
		CapacitorPluginSce.setCarrierCode({carrierCode : this.cpsSaisie});
		this.demandeCodeCPS = false;
	}

	public validateCpsSaisie(){
		this.cpsSaisie = FormHelper.validCPSCode(this.cpsSaisie);
		this.cdr.detectChanges()
	}
}
